import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapsHotelsComponent } from './components/maps-hotels/maps-hotels.component';
import { FormsModule } from '@angular/forms';
import { AAGoogleMapModule } from '../google-map/aa-google-map.module';
import { MapOptionsComponent } from './components/map-options/map-options.component';
import { AACoreModule } from '../aa-core/aa-core.module';
import { MapPrintPreviewComponent } from './components/map-print-preview/map-print-preview.component';

@NgModule({
  declarations: [MapsHotelsComponent, MapOptionsComponent, MapPrintPreviewComponent],
  imports: [
    CommonModule,
    AAGoogleMapModule,
    AACoreModule,
    FormsModule
  ]
})
export class MapsHotelsModule { }
